Vue.component('posts-list', require('./components/PostsList.vue').default);
Vue.component('post-category-select', require('./components/PostCategorySelect.vue').default);
Vue.component('post-form', require('./components/PostForm.vue').default);
Vue.component('newsfeed', require('./components/Newsfeed.vue').default);